import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { BackendService } from '@toro/common/shared/services/new-http/backend.service';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { FittingAcceptResponse, FittingResponse, ProfileResponse } from '../../models/santander-suitability/santander-suitability.model';

export class AcceptTermPayload {
  constructor(
    public product: string,
    public subProduct: string,
    public investmentValue: number,
    public temporaryDocumentId: number,
  ) { }
}

export class FittingPayload {
  constructor(
    public product: string,
    public subProduct: string,
    public investmentValue: number,
  ) { }
}

@Injectable()
export class SantanderSuitabilityService {
  constructor(
    private backendService: BackendService,
    private store: Store<AppState>
  ) { }

  public sessionId: string;

  /**
   * Obtém o perfil de suitability do investidor.
   *@returns Um `Observable<ProfileResponse>` com a resposta da API contendo o perfil do cliente.
   */
  public getProfile(): Observable<ProfileResponse> {
    try {
      this.fillSessionId();
      return this.backendService.api.get(`/oq/v1/profile`);
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Verifica o enquadramento do investimento proposto com o perfil do investidor.
   * Envia um payload com detalhes do investimento para validação.
   *@param {FittingPayload} payload - Os dados do investimento a serem verificados.
   *@returns Um `Observable<FittingResponse>` com a resposta da API sobre o enquadramento.
   */
  public checkFitting(payload: FittingPayload): Observable<FittingResponse> {
    this.fillSessionId();
    return this.backendService.api.post(
      `/oq/v1/profile/fittings`,
      payload
    );
  }

  /**
   * Envia a aceitação dos termos de enquadramento do investimento.
   *@param {AcceptTermPayload} payload - Os dados da aceitação do termo.
   *@returns Um `Observable<FittingAcceptResponse>` com a resposta da API após o aceite do termo.
   */
  public acceptTerm(payload: AcceptTermPayload): Observable<FittingAcceptResponse> {
    this.fillSessionId();
    return this.backendService.api.post(
      `/oq/v1/profile/fittingAccept`,
      payload
    );
  }

  private fillSessionId = () => {
    this.store
      .select(({ authentication }) => authentication.currentUser)
      .pipe(
        filter((authentication) => !!authentication)
      )
      .subscribe((user) => {
        this.sessionId = user.sessionId
      })
  }
}
